import { render, staticRenderFns } from "./MoreTable.vue?vue&type=template&id=0c023b17&scoped=true&"
import script from "./MoreTable.vue?vue&type=script&lang=js&"
export * from "./MoreTable.vue?vue&type=script&lang=js&"
import style0 from "./MoreTable.vue?vue&type=style&index=0&id=0c023b17&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c023b17",
  null
  
)

export default component.exports